export default function useUser() {
  return global.__AT_STORE__.user;
}
